module.exports = __webpack_public_path__ + "static/media/play_btn_small_normal.0d3dac39.svg";